import React from 'react';
import abelardo from '../assets/img/abelardo.png'
import '../styles/Style.css'
const SVCFooter = () => {

    return (
        <>
            <div className='footerSCV'>
                <span>© 2024 PG, all rights reserverd.</span>
                <img src={abelardo} alt="Abelardo eyes ©" />
            </div>
        </>
    )
}

export default SVCFooter;
